<template>
  <div class="tab-pane active">
    <ul class="catalog__tab-list">
      <filter-block
          title="Бренд"
          :type="type"
          filter-key="brand"
          :force-shown="true"
          :loading="loading" />
      <filter-block
        title="Бизнес"
        :type="type"
        filter-key="business"
        :force-shown="true"
        :loading="loading"
        :isCategorized="true" />
      <filter-block
        title="Категория"
        :type="type"
        filter-key="category"
        :force-shown="true"
        :loading="loading"
        :isCategorized="true" />
      <filter-block
        title="Подкатегория"
        :type="type"
        filter-key="subcategory"
        :loading="loading"
        :isCategorized="true" />
      <filter-block
        title="Серия товара"
        :type="type"
        filter-key="range"
        :loading="loading"
        :isCategorized="true" />
    </ul>
  </div>
</template>

<script>
import { SET_FILTER_DATA, SET_QUERY_FILTER, SEARCH, SET_BUFFER_LINES } from '@/store/actions/search'
import FilterBlock from '@/components/FilterBlock'
import { mapGetters } from 'vuex'

export default {
  name: 'filter-type-common',
  components: {
    FilterBlock
  },
  data: () => ({
    loading: true,
  }),
  created () {
    if (this.isEmptyData(this.type)) {
      this.api.then((response) => {
        const { data } = response
        this.$store.dispatch(SET_FILTER_DATA, { data, type: this.type }).then(() => {
          const { query } = this.$route
          if (query && Object.keys(query).length) {
            if (query?.lines) {
              this.$api.catalog.lines({ id: query.lines }).then((response) => {
                if (!response.data.length) {
                  delete query.lines
                } else {
                  const { id, name } = response.data[0]
                  this.$store.dispatch(SET_BUFFER_LINES, { [id]: name })
                }
                this.setQueryFilter(query)
              })
            } else {
              this.setQueryFilter(query)
            }            
          } else {
            this.loading = false
          }          
        })
      })
    } else {
      this.loading = false
    }
  },
  computed: {
    type () {
      return 'common'
    },
    api () {
      return this.$api.filter.common()
    },
    ...mapGetters(['isEmptyData'])
  },
  methods: {
    setQueryFilter (query) {
      this.$store.dispatch(SET_QUERY_FILTER, query).then(() => {
        this.$store.dispatch(SEARCH, { reset: false })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
